export default __webpack_public_path__ + "static/media/2266_open.67fcf9a4.jpg";